module.exports = require('./src/fixed-game-loop.js');
